import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import { Url } from "../../config/config";
import Modal from "react-bootstrap/Modal";
import useButtonLoader from "../../hooks/useButtonLoader";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { dateFormat } from "../../utils";
import useDebounce from "../../hooks/useDebounce";

export default function FinancialPartnerType() {
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  //const [activePage, setActivePage] = useState(1)
  const [BlockModal, setBlockModal] = useState(false);
  const [inputField, setInputField] = useState({
    status: true,
    id: "",
  });

  const { status, id } = inputField;
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const currentActivePage = parseInt(
    localStorage.getItem("financialActivePage")
  );
  const [activePage, setActivePage] = useState(currentActivePage || 1);

  const [searchValue, setSearchValue] = useState("");
  const debounceValue = useDebounce(searchValue, 500);
  //********************Partner List***************************************** */
  const financialPartnerList = async (page = 1, query = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/financialPartnerMgmt?page=${page}&search=${query}`,
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();
      if (res.status === 200) {
        console.log(res.data.data.partnerList);
        setRecord(res.data.data.partnerList);
        setTotal(res.data.data.total);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
    // console.log(res.data.result);
  };

  //**************Handel update status************** */
  const handleChecked = (e, id) => {
    handelBlockShow();
    setInputField({
      ...inputField,
      status: e.target.checked,
      id: id,
    });
  };

  const handelBlockClose = () => {
    setBlockModal(false);
  };
  const handelBlockShow = () => {
    setBlockModal(true);
  };

  const handelUpdateStatus = async () => {
    try {
      let res = await axios({
        url: `${Url}/financialPartnerMgmt/status`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          partnerId: id,
          status: status,
        },
      });
      handelBlockClose();
      toast.success(res.data.message);
      financialPartnerList();
    } catch (err) {
      console.log(err);
    }
  };

  //************Approved Request Status********** */
  const [approved, updateApproved] = useState(false);
  const handelApprovedOpen = (id) => {
    console.log("id ", id);
    updateApproved(true);
    setInputField({
      ...inputField,
      id: id,
    });
  };

  const handelApprovedClose = () => {
    updateApproved(false);
  };

  const handelApprovedRequest = async (e) => {
    try {
      e.preventDefault();
      console.log("hi", id);
      let res = await axios({
        url: `${Url}/partnerapprovedRequest`,
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          partnerId: id,
        },
      });
      if (res.data.status === 200) {
        handelApprovedClose();
        toast.success("Financial Partner request approved successfully");
        financialPartnerList();
      } else {
        toast.error("Something wents wrong, please try again");
      }
    } catch (err) {
      toast.error("Something wents wrong, please try again");
      console.log(err);
    }
  };

  //*****************Handel Delete Action****************** */
  const [DeleteModal, setDeleteModal] = useState(false);
  const handelDeleteShow = (id) => {
    //console.log(id);
    setDeleteModal(true);
    setInputField({ ...inputField, id: id });
  };
  const handelDeleteClose = () => {
    setDeleteModal(false);
  };

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/financialPartnerMgmt?partnerId=${id}`,
        method: "DELETE",
      });
      if (res.data.status === 200) {
        handelDeleteClose();
        toast.success(res.data.message);
        financialPartnerList(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    financialPartnerList(activePage, debounceValue)
    localStorage.setItem("financialActivePage", activePage);
  }, [activePage, debounceValue]);

  //**********************Handel Pagination OnChange */
  const handlePageChange = (event) => {
    setActivePage(event);
    financialPartnerList(event);
  };

  //******************** Handel Search**************************** */
  const handelSearch = (e) => {
    setSearchValue(e.target.value);
  };

  var count = (activePage - 1) * 10 + 1;

  return (
    <React.Fragment>
      <title>Financial Partner Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />

              <Link to="/financial-partner/add" className="button py-auto">
                Add&nbsp;Partner
              </Link>
            </div>
            <h4 className="Title">Financial Partner Management</h4>
            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Financial Company Name</th>
                    <th>Category Type</th>
                    <th>Mobile Number</th>
                    <th>City</th>
                    <th>Registered Date</th>
                    <th>Details</th>
                    <th>Status</th>
                    <th>Approved Status</th>
                    <th>action</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => (
                      <tr key={i}>
                        <td>{count++}</td>

                        <td>{item.financeCompanyName}</td>
                        <td>{item.financeCompanyType}</td>
                        <td>{item.contactNum}</td>
                        <td>{item.city}</td>
                        <td>{dateFormat(item.createdAt)}</td>
                        <td>
                          <Link to={`/financial-partner/details/${item._id}`}>
                            View
                          </Link>
                        </td>

                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="status"
                              checked={item.status}
                              onChange={(e) => handleChecked(e, item._id)}
                            />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          {item &&
                            item.profileStatus &&
                            item.profileStatus === "pending" ? (
                            <button
                              onClick={(e) => {
                                handelApprovedOpen(item._id);
                              }}
                            >
                              Pending
                            </button>
                          ) : (
                            "Approved"
                          )}
                        </td>
                        <td>
                          <span
                            className="Red"
                            onClick={(e) => handelDeleteShow(item._id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="ModalBox">
        {/* Start Delete Modal */}
        <Modal show={DeleteModal} onHide={handelDeleteClose}>
          <Modal.Header closeButton onClick={handelDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure want to delete this financial partner?
          </Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handelDeleteClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelDelete}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* End delete Modal */}

        {/* block or unblock model */}
        <Modal show={BlockModal} onHide={handelBlockClose}>
          <Modal.Header closeButton onClick={handelBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handelBlockClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelUpdateStatus}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* end block unblock modal */}

        {/* Approved Request */}
        <Modal show={approved} onHide={handelApprovedClose}>
          <Modal.Header closeButton onClick={handelApprovedClose}>
            <Modal.Title>Approved Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to Approved Request of this partner?
          </Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handelApprovedClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={(e) => {
                handelApprovedRequest(e);
              }}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
}
